export const getFilterData = (data, filterText, filterTextId) => {
  if (!data) return [];
  const seen = new Set();
    const uniqueData = data
      .filter(row => row[filterText] && !seen.has(row[filterText]) && seen.add(row[filterText]))
      .map(row => ({ value: row[filterTextId], label: row[filterText] }));
    uniqueData.sort((a, b) => a.label.localeCompare(b.label));
    return [{ value: 0, label: "All" }, ...uniqueData];
};

